import React from "react";

interface AnimatedCounterProps {
  count: number;
}

export const AnimatedCounter: React.FC<AnimatedCounterProps> = ({ count }) => {
  return (
    <div className="relative">
      <div className="text-9xl font-bold text-heartRed dark:text-softRose tabular-nums">
        {String(count).padStart(2, "0")}
      </div>
    </div>
  );
};
